import * as z from 'zod'

export const sourceSchema = z.object({
  file: z.instanceof(File),
  sourceKey: z.string()
  // targetKey: z.string(),
  // dateKey: z.string()
})
